import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'

import { IProcedureCodeset } from './procedureCodeset'
import { ODataService } from 'common-services'

export interface IProcedureCode extends IModelBase {
  Px: string
  Description: string
  RefProcedureCodeSetId: number
  ProcedureCodeset: IProcedureCodeset
  ActiveOnDateTime: Date
  ActiveThruDateTime: Date
}

@Injectable()
export class ProcedureCodeODataService extends ODataService<IProcedureCode> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'RefProcedureCodes'
  }
}
